<mc-doughnut-chart [options]="chartOptions" [data]="(chartDataAndStatuses$ | async)?.Data" [holeIndex]="0" [holeType]="DoughnutChartHoleType.Percentage">
  <ng-template mcDoughnutChartHole let-hole>
    <span class="mc-doughnut-chart-hole-value">{{ hole.value | percent }}</span>
    <span class="mc-doughnut-chart-hole-label">{{ hole.label }}</span>
  </ng-template>
</mc-doughnut-chart>

<div class="mc-project-checklist-doughnut-chart-hole" *ngIf="(chartDataAndStatuses$ | async)?.Statuses as statuses">
  <span class="mc-text-checklist-completed text-light-weight text-xxxx-large">{{ statuses.Completed | number:'1.0-0' }}%</span>
  <span class="mc-text-muted text-large text-light-weight">Complete</span>
  <div>
    <div class="mc-project-checklist-doughnut-chart-dot-wrapper">
      <span class="mc-dot mc-dot-large mc-checklist-in-progress">{{ statuses.InProgress | number:'1.0-0' }}%</span>
      <span class="mc-text-muted"> In Progress</span>
    </div>
    <div class="mc-project-checklist-doughnut-chart-dot-wrapper">
      <span class="mc-dot mc-dot-large mc-checklist-todo">{{ statuses.ToDo | number:'1.0-0' }}%</span>
      <span class="mc-text-muted"> To Do</span>
    </div>
  </div>
</div>